import {
	SET_SUBHEADER_TEXT,
	SET_SUBHEADER_ACTIONS,
	SET_CREATABLE_CONTEXT,
} from "../actions/types";

const initialState = {
	title: "Welcome to LexWorkplace",
	chips: [],
	component: null,
	subheaderActions: null,
	creatableContext: false,
	subheaderIconName: null,
};

export default function (state = initialState, action) {
	switch (action.type) {
		case SET_SUBHEADER_TEXT:
			return {
				...state,
				title: action.payload.subheaderText,
				chips: action.payload.subheaderChips || [],
				subheaderIconName: action.payload.subheaderIconName,
				subheaderActions: null,
				subHeaderHeight: action.payload.subHeaderHeight
					? action.payload.subHeaderHeight
					: 64,
			};
		case SET_SUBHEADER_ACTIONS:
			return {
				...state,
				subheaderActions: action.payload,
			};
		case SET_CREATABLE_CONTEXT:
			return {
				...state,
				creatableContext: action.payload,
			};
		default:
			return state;
	}
}
